import React, { useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import { skillArr, translations } from '../services/arrays'
import { getTranslation } from '../services/translations'

const SkillUpdateHistory = ({ history, lang }) => {
  const [isOpen, setIsOpen] = useState(false)
  const t = key => getTranslation(lang, key)

  if (!Array.isArray(history) || history.length === 0) return null

  return (
    <div>
      <Button
        size="sm"
        onClick={() => setIsOpen(previous => !previous)}
        aria-expanded={isOpen}
        style={{
          width: '100%',
          backgroundColor: '#1E2124',
          borderColor: '#1E2124',
          color: '#FFFFFF',
          fontSize: '0.8rem',
        }}
      >
        {isOpen ? t('hideSkillUpdateHistory') : t('skillUpdateHistory')}
      </Button>

      {isOpen && (
        <Card
          className="mt-2"
          style={{
            backgroundColor: '#23272A',
            color: '#FFFFFF',
            borderColor: '#1E2124',
          }}
        >
          <Card.Body style={{ padding: '8px 10px' }}>
            {[...history].reverse().map((entry, index) => {
              const changes = skillArr
                .filter(
                  skill =>
                    Number(entry.previousSkills?.[skill]) !==
                    Number(entry.updatedSkills?.[skill])
                )
                .map(skill => {
                  const label =
                    translations[skill]?.[lang === 'en' ? 1 : 0] || skill
                  const previous = Number(entry.previousSkills?.[skill]).toFixed(3)
                  const updated = Number(entry.updatedSkills?.[skill]).toFixed(3)
                  return { skill, label, previous, updated }
                })

              return (
                <div
                  key={entry._id || `${entry.updatedAt}-${index}`}
                  style={{
                    borderBottom:
                      index < history.length - 1 ? '1px solid #343a40' : 0,
                    padding: '5px 0',
                    fontSize: '0.75rem',
                  }}
                >
                  <div style={{ color: '#99AAB5', fontSize: '0.7rem' }}>
                    {entry.updatedAt
                      ? new Date(entry.updatedAt).toLocaleString(
                          lang === 'en' ? 'en-GB' : 'fi-FI',
                          { dateStyle: 'short', timeStyle: 'short' }
                        )
                      : '-'}
                    {entry.updatedBy?.loginName
                      ? ` · ${entry.updatedBy.loginName}`
                      : ''}
                  </div>
                  {changes.length > 0 ? (
                    <div>
                      {changes.map(change => (
                        <div key={change.skill}>
                          {change.label}: {change.previous} -&gt;{' '}
                          {change.updated}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>-</div>
                  )}
                </div>
              )
            })}
          </Card.Body>
        </Card>
      )}
    </div>
  )
}

export default SkillUpdateHistory
